import { createFileRoute } from '@tanstack/react-router';
import AuthGuard from '@/components/auth-guard';
import ModernAuthForm from '@/components/modern-auth-form';

interface LoginSearch {
  redirect?: string;
  mode?: string;
  email?: string;
}

export const Route = createFileRoute('/login')({
  validateSearch: (search): LoginSearch => ({
    redirect: typeof search.redirect === 'string' ? search.redirect : undefined,
    mode: typeof search.mode === 'string' ? search.mode : undefined,
    email: typeof search.email === 'string' ? search.email : undefined,
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const { mode, email, redirect } = Route.useSearch();

  // Convert mode to the expected format
  const initialMode = mode === 'signup' ? 'signup' : 'signin';

  return (
    <AuthGuard redirectTo={redirect || '/dashboard'} requireAuth={false}>
      <ModernAuthForm
        initialMode={initialMode}
        prefilledEmail={email}
        redirectTo={redirect}
      />
    </AuthGuard>
  );
}
